// src/pages/About.tsx
import React from 'react';

const LEADERSHIP = [
  { role: 'Commissioner', name: 'Terrence Wong' },
  { role: 'President', name: 'Patrick Asfour' },
];

const About: React.FC = () => {
  return (
    <div className="bga-page" style={{ maxWidth: 720 }}>
      <div className="bga-page-header">
        <div>
          <h1 className="bga-h1">About</h1>
          <p className="bga-sub">Meet the Broskies Golf Association.</p>
        </div>
      </div>

      <div className="bga-card">
        <h2 className="bga-card-title">Leadership</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {LEADERSHIP.map((person) => (
            <div
              key={person.role}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                padding: '12px 14px',
                border: '1px solid var(--bga-border)',
                borderRadius: 10,
                background: '#fff',
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 42,
                  height: 42,
                  borderRadius: '50%',
                  background: 'var(--bga-green-tint)',
                  fontSize: 20,
                  flexShrink: 0,
                }}
              >
                ⛳
              </span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{person.name}</div>
                <div className="bga-muted" style={{ fontSize: 13 }}>{person.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
